import { render, staticRenderFns } from "./TypePanel.vue?vue&type=template&id=5a244d3a&scoped=true"
import script from "./TypePanel.vue?vue&type=script&lang=js"
export * from "./TypePanel.vue?vue&type=script&lang=js"
import style0 from "./TypePanel.vue?vue&type=style&index=0&id=5a244d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a244d3a",
  null
  
)

export default component.exports